<app-topbar></app-topbar>
<main class="layout-container">
  <p-toast></p-toast>
  <ngx-loading
    [show]="loading"
    [config]="{
      animationType: ngxLoadingAnimationTypes.circleSwish,
      primaryColour: '#1976d2',
      backdropBorderRadius: '3px',
      fullScreenBackdrop: true,
    }"/>
    <div class="layout-content-wrapper">
    <div class="layout-content">
      <div class="grid justify-content-center">
        <div class="col-12 md:col-12">
    <div *ngIf="avatarImage && isCropping" class="crop-container">
        <img #imagemElemento [src]="avatarImage" alt="Imagem para Recorte" />
        <div class="crop-actions">
          <p-button label="Recortar" (onClick)="recortarImagem()"></p-button>
          <p-button label="Cancelar" severity="secondary" (onClick)="cancelarRecorte()"></p-button>
        </div>
      </div>

      <p-card class="card custom-card">
        <ng-template pTemplate="header">
          <div class="card-header">
            <h3 class="card-title">Bem-vindo, {{ userName }}!</h3>
          </div>
        </ng-template>
        <form>
            <div class="grid">
            <div class="col-12 flex align-items-center gap-5">
             <label style="cursor: pointer;" [ngClass]="{'icon-edit': isEditing}">
                <input
                    type="file"
                    style="display: none;"
                    accept="image/*"
                    (change)="onFileSelected($event)"
                    [disabled]="!isEditing"
                />
                <p-avatar
                    *ngIf="isEditing && !isCropping"
                    styleClass="avatarImage"
                    [image]="avatarImage"
                    pBadge
                    size="xlarge">
                </p-avatar>
                <p-avatar
                    *ngIf="!isEditing && !isCropping"
                    styleClass="avatarImage"
                    [image]="avatarImage"
                    size="xlarge">
                </p-avatar>
            </label>
          </div>

                <div class="col-12 flex align-items-center gap-5">
                    <div>
                        <h3 class="m-0 text-xl font-bold">{{ userName }}</h3>
                        <p class="m-0 text-500">{{ userOrgao }}</p>
                    </div>
                </div>
            </div>
            <!--Campos do perfil-->
            <div class="col-12 md:col-6">
              <label for="nome" class="font-normal">Nome
              </label>
              <input
                title="Seu nome completo"
                class="mt-1"
                pInputText
                [(ngModel)]="userName" name="userName"
                [disabled]="true"
              />
            </div>
            <div class="col-12 md:col-6">
              <label for="frase" class="font-normal">Como você quer ser chamado?
              </label>
              <input
                title="Seu apelido"
                class="mt-1"
                pInputText
                [(ngModel)]="userApelido" name="userApelido"
                [disabled]="!isEditing"
              />
            </div>
            <div class="col-12 md:col-6">
              <label for="frase" class="font-normal">Informe seu email
              </label>
              <input
                title="Não editável porque é fixo no ato da criação da conta"
                class="mt-1"
                pInputText
                contenteditable="false"
                [(ngModel)]="userEmail" name="userEmail"
                [disabled]="!isEditing"
              />
            </div>
            <div class="col-12 md:col-6">
              <label for="frase" class="font-normal">Digite uma frase para seu status
              </label>
              <input
                title="Sua frase de status"
                class="mt-1"
                pInputText
                [(ngModel)]="userFrase" name="userFrase"
                [disabled]="!isEditing"
              />
            </div>
            <div class="col-12 flex flex-wrap gap-2 mt-3">
              <p-button class="botao-salvar" label="Salvar" size="small"  (onClick)="onSubmit()"  [disabled]="isCropping || !isEditing"/>
              <p-button label="Editar" severity="info" icon="pi pi-pencil" size="small" (onClick)="toggleEdit()"/>
              <p-button label="Voltar" severity="secondary" size="small"  [routerLink]="'/painel'"/>
          </div>
        </form>
    </p-card>
    </div>
    </div>
    </div>
    </div>
</main>
